import React, { Component } from "react";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import { BarChart, MediumBarChart } from "../../components/bar-chart/";
import styles from "./chart-area.module.scss";
import * as selectors from "../../reducers";
import { humanizeNumber } from "../../helpers/formatters";

class ChartArea extends Component {
  constructor() {
    super();
    this.chartMapper = this.chartMapper.bind(this);
  }

  getLegendPhrase(chartData) {
    const { activeCouncil } = this.props;
    const area = activeCouncil[chartData.area];
    return area + " HHSs";
  }

  renderTrend(trend) {
    if (!trend) {
      return null;
    }

    const color = "#9a8273";
    return (
      <span
        style={{
          color,
          marginRight: 10,
        }}
      >
        {trend === "−" ? "No Trend" : `Trend ${trend}`}
      </span>
    );
  }
  isTextBarChart(data) {
    return data.max === "High";
  }

  // not the nicest, I'm sorry.
  getAdditionalChartText(title) {
    switch (title) {
      case "Operating Surplus Ratio": {
        return " The state government’s target for the HHS is between 0 and 10 per cent.";
      }
      case "Net Financial Liabilities": {
        return " The state government’s target for the HHS is less than 60 per cent.";
      }
      case "Asset Sustainability Ratio": {
        return " The state government’s target for the HHS is greater than 90 per cent.";
      }
      default: {
        return null;
      }
    }
  }

  // chartData is already processed, e.g.
  // 0: {type: "main", value: 627, min: 0, max: 627, trueMin: 516}
  // 1: {type: "median", area: "classification", min: 0, max: 627, value: 544.5}
  // 2: {type: "text", min: 0, max: 895, trueMin: 346}
  chartMapper(chartData, index) {
    const {
      color,
      unit,
      activeCouncil,
      comparedCouncil,
      title,
      // councils,
      visible,
      trend,
    } = this.props;

    switch (chartData.type) {
      case "main":
        return (
          <BarChart
            key={index}
            data={chartData}
            color={color}
            unit={unit}
            tickIsHidden={activeCouncil.isBlank}
            visible={visible}
          >
            {this.renderTrend(trend)}
            {activeCouncil.name}
          </BarChart>
        );
      case "compared":
        return (
          <BarChart
            key={index}
            data={chartData}
            color={color}
            unit={unit}
            tickIsHidden={comparedCouncil.isBlank}
            visible={visible}
          >
            {this.renderTrend(trend)}

            {comparedCouncil.name}
          </BarChart>
        );
      case "median":
        // const medianCount = councils.filter((council) => {
        //   // E.g. chartData.area === "classification", and Cairns and Hinterland's 'classification' is 'large regional'.
        //   return (
        //     council[chartData.area] === activeCouncil[chartData.area] &&
        //     !council.isBlank
        //   );
        // });

        // Doing this based on valid data returned from calculating functions
        // Rather than recalculating it here
        const medianCount = chartData.numValidElems;

        if (chartData.max === "High") {
          // No median for text bar chart
          return null;
        }

        return (
          <MediumBarChart
            key={index}
            data={chartData}
            color={color}
            unit={unit}
            visible={visible}
          >
            <div className={styles.chartLegend}>
              Median of {medianCount}{" "}
              <span className={styles.chartLegendBold}>
                {this.getLegendPhrase(chartData)}
              </span>
            </div>
          </MediumBarChart>
        );
      case "text":
        const additionalText = this.getAdditionalChartText(title);
        const truncatedDataText =
          chartData.numValidElems < chartData.numElems
            ? " Only HHSs with recorded data are included in this comparison."
            : "";
        return (
          <div key={index} className={styles.chartBottomText}>
            <span>{title}</span> reported for Queensland HHSs ranged from{" "}
            {humanizeNumber(chartData.trueMin, unit)} to{" "}
            {humanizeNumber(chartData.max, unit)}.{" "}
            {comparedCouncil || this.isTextBarChart(chartData)
              ? null
              : "Median is the middle value in the selected data range."}
            {truncatedDataText && truncatedDataText}
            {additionalText && additionalText}
          </div>
        );
      default:
        return null;
    }
  }

  render() {
    const { data } = this.props;
    return data.map((d, i) => this.chartMapper(d, i));
  }
}

const mapStateToProps = (state) => ({
  activeCouncil: selectors.getActiveCouncil(state),
  councils: selectors.getCouncils(state),
  comparedCouncil: selectors.getComparedCouncil(state),
});

ChartArea.propTypes = {
  activeCouncil: PropTypes.object.isRequired,
  comparedCouncil: PropTypes.object,
  data: PropTypes.array.isRequired,
  color: PropTypes.string.isRequired,
  unit: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, null)(ChartArea);



// WEBPACK FOOTER //
// ./src/components/data-card-row/chart-area.js